// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_1Ej7RDZpLPU7B4q5VvBBRo"};